import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDebounce } from 'use-debounce';
import { Avatar, Button, Checkbox, Input, Loading, ModalBox, useModalContext, } from '@fourthwall/components';
import { SearchIcon } from '@fourthwall/icons';
import { pluralize } from '@fourthwall/utils/dist/string';
import { useMembersInfiniteQuery } from './hooks/useMembersInfiiniteQuery';
import * as S from './styled';
export const SelectMembers = ({ selectedMembers, onSave }) => {
    const modal = useModalContext();
    const [innerSelectedMembers, setSelectedMembers] = React.useState(selectedMembers || []);
    const [searchQuery, setSearchQuery] = React.useState();
    const [searchQueryDebounced] = useDebounce(searchQuery, 300);
    const { membersInfiniteQuery } = useMembersInfiniteQuery(searchQueryDebounced);
    const members = membersInfiniteQuery.data?.pages.flatMap((page) => page.members);
    const renderContent = () => {
        if (membersInfiniteQuery.isFetching) {
            return (React.createElement(S.EmptyState, null,
                React.createElement(Loading, { isLoading: true })));
        }
        if (!searchQueryDebounced || searchQueryDebounced.length < 3) {
            return React.createElement(S.EmptyState, null, "Search for members");
        }
        if (!members?.length) {
            return React.createElement(S.EmptyState, null, "No members found");
        }
        return (React.createElement(S.TableContainer, { id: "scrollableDiv" }, members?.map((member) => (React.createElement(S.Container, null,
            React.createElement(S.CheckboxContainer, null,
                React.createElement(Checkbox, { value: !!innerSelectedMembers.find((selectedMember) => selectedMember.id === member.id), onValueChange: (value) => {
                        if (value) {
                            setSelectedMembers((prevSelectedMembers) => [
                                ...prevSelectedMembers,
                                {
                                    id: member.id,
                                    nickname: member.nickname,
                                    avatarUrl: member.avatarUrl,
                                },
                            ]);
                        }
                        else {
                            setSelectedMembers((prevSelectedMembers) => prevSelectedMembers.filter((prevSelecterMember) => prevSelecterMember.id !== member.id));
                        }
                    } })),
            React.createElement(Avatar, { name: member.nickname, imageUrl: member.avatarUrl, size: "small" }),
            React.createElement(S.Nickname, null, member.nickname))))));
    };
    return (React.createElement(ModalBox, { title: "Select members", onClose: modal.close, footer: React.createElement(React.Fragment, null,
            innerSelectedMembers.length,
            " ",
            pluralize(innerSelectedMembers.length, 'member'),
            " selected"), buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: modal.close }),
            React.createElement(Button, { label: "Save", appearance: "primary", onClick: () => {
                    onSave(innerSelectedMembers);
                    modal.close();
                } }),
        ] },
        React.createElement(Input, { size: "medium", placeholder: "Search members", fullWidth: true, leftIcon: SearchIcon, onValueChange: setSearchQuery, value: searchQuery }),
        React.createElement(InfiniteScroll, { dataLength: members?.length || 0, next: membersInfiniteQuery.fetchNextPage, hasMore: !!membersInfiniteQuery.hasNextPage, loader: null, scrollableTarget: "scrollableDiv", style: {
                overflow: 'none',
            } },
            React.createElement(Loading, { isLoading: membersInfiniteQuery.isFetching }, renderContent()))));
};
